module.exports = __webpack_public_path__ + "img/平山旅游.a9c3b99f.jpg";